module.exports = function(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-json-inspector/lib/type.js
 ** module id = 92
 ** module chunks = 0
 **/